export default __webpack_public_path__ + "static/media/Blog4_3.4bab52e5.jpg";